import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_OTP_COOLDOWN } from '@app/config/app.config';

import * as css from './login.module.scss';

export interface OtpResendLinkComponentProps {
  onResendOtp: () => void;
}

export const OtpResendLinkComponent = ({
  onResendOtp,
}: OtpResendLinkComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [otpCooldown, setOtpCooldown] = useState<number>(10);

  const startCooldownOtp = () => {
    let cooldown = DEFAULT_OTP_COOLDOWN;
    const interval = setInterval(() => {
      if (cooldown === 0) {
        clearInterval(interval);
      }
      setOtpCooldown(cooldown);
      cooldown -= 1;
    }, 1000);

    return interval;
  };

  useEffect(() => {
    const timer = startCooldownOtp();
    return () => clearInterval(timer);
  }, []);

  const handleResendOtp = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.preventDefault();
    if (otpCooldown <= 0) {
      startCooldownOtp();
      onResendOtp();
    }
  };

  if (otpCooldown > 0) {
    return (
      <Stack gap={GapEnum.XS} className={css.waitResendEmail}>
        <Text>{t('$.login.otp-step.resend-email-timer')}</Text>
        <Link role="button" disabled className={css.resendEmail}>
          {t('$.login.otp-step.resend-email-cooldown', { otpCooldown })}
        </Link>
      </Stack>
    );
  }

  return (
    <Link role="button" onClick={handleResendOtp} className={css.resendEmail}>
      {t('$.login.otp-step.resend-email')}
    </Link>
  );
};
